class MediaFeatureVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initVideo();
  }

  async initVideo() {
    const videoContainer = this.querySelector('video');
    if (!videoContainer) return;

    const videoLoad = { name: 'video-ui', version: '1.0' };

    if (window.theme?.loadScript) {
      await window.theme.loadScript(videoLoad);
    } else if (window.Shopify?.loadFeatures) {
      await new Promise((resolve) => {
        window.Shopify.loadFeatures([videoLoad], resolve);
      });
    }

    if (window.Shopify?.Plyr) {
      new window.Shopify.Plyr(videoContainer);
    }
  }
}

customElements.define('media-feature-video', MediaFeatureVideo);
